import {createAction} from '@reduxjs/toolkit';

import {AlertType} from 'store/types/app';

export const setAlertAction = createAction<
  | {
      type: AlertType;
      details?: unknown;
    }
  | undefined
>('SET_ALERT_ACTION');
